import { TextDisplay, Heading1, Flex, Link, Message } from '@libs/ahoy/src';

import logo from './images/teamleader_logo_default.svg';
import * as styles from './index.css';
import { useFlagsWithFallback } from './useFlagsWithFallback';

export default function App() {
  const { downtimeTimeAndDateValue, downtimeDescription } = useFlagsWithFallback();

  let timeAndDateFormatted = '';

  if (Date.parse(downtimeTimeAndDateValue)) {
    const timeAndDate = new Date(downtimeTimeAndDateValue);

    if (!isNaN(timeAndDate.getTime())) {
      timeAndDateFormatted = timeAndDate.toLocaleString(navigator.language, {
        dateStyle: 'medium',
        timeStyle: 'long',
      });
    }
  }

  return (
    <Flex className={styles['container']} direction="column">
      <Flex justifyContent="center" paddingVertical={6} element="header">
        <img src={logo} alt="Teamleader logo" title="Teamleader logo" className={styles['logo']} />
      </Flex>
      <Flex
        direction="column"
        justifyContent="center"
        alignItems="center"
        flex={1}
        element="main"
        paddingHorizontal={4}
      >
        <Heading1 marginBottom={6}>Teamleader Focus is currently unavailable</Heading1>
        {downtimeDescription && (
          <Message marginBottom={3} showIcon>
            <TextDisplay>{downtimeDescription}</TextDisplay>
          </Message>
        )}
        <TextDisplay marginBottom={3}>
          {"We apologize for the inconvenience. We'll be back up and running "}
          {timeAndDateFormatted ? (
            <>
              at around <strong>{timeAndDateFormatted}</strong>
            </>
          ) : (
            'soon'
          )}
          .
        </TextDisplay>
        <TextDisplay>
          Subscribe to our{' '}
          <Link inherit={false} href="https://status.teamleader.eu">
            statuspage
          </Link>
          , to stay updated!
        </TextDisplay>
      </Flex>
      <Flex className={styles['main-image-container']} marginTop={6} />
    </Flex>
  );
}
